import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './InboundOrigination.css';

const InboundOrigination = () => {
  return (
    <div className="inbound-container">
      <div className="inbound-hero">
        <motion.div 
          className="inbound-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="inbound-hero-title">Inbound Origination</h1>
          <h2 className="inbound-hero-subtitle">
            Seamless Voice Traffic Origination with Global Reach
          </h2>
          <Link to="/contact" className="inbound-cta-btn">
            <motion.button
              className="inbound-cta-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started
            </motion.button>
          </Link>
        </motion.div>
      </div>

      <div className="inbound-content">
        <div className="inbound-intro-section">
          <h2 className="inbound-section-title">About Our Company</h2>
          <h3 className="inbound-subsection-title">Why Choose DirectRoutes Networks?</h3>
          <p className="inbound-subsection-subtitle">Expertise. Reach. Support.</p>
          <p className="inbound-intro">
            With years of experience in global voice services, our team acts as a strategic partner—helping you stay connected, competitive, and compliant. Whether you are a service provider, call center, enterprise, or application developer, DirectRoutes Networks delivers inbound origination services you can trust.
          </p>
        </div>

        <div className="inbound-text-section">
          <h2 className="inbound-section-title">What We Offer</h2>
        </div>

        <div className="inbound-text-section">
          <h3 className="inbound-subsection-title">Carrier-Grade Call Quality</h3>
          <p className="inbound-section-text">
            We provide low-latency, high-availability inbound voice services through our trusted global carrier partnerships, ensuring clear and uninterrupted communication.
          </p>
        </div>

        <div className="inbound-text-section">
          <h3 className="inbound-subsection-title">Powerful Management Tools</h3>
          <p className="inbound-section-text">
            Gain access to real-time analytics, call detail records (CDRs), and provisioning controls via our intuitive online portal.
          </p>
        </div>

        <div className="inbound-text-section">
          <h3 className="inbound-subsection-title">Flexible SIP Trunking</h3>
          <p className="inbound-section-text">
            Integrate effortlessly with your existing IP PBX, contact center, or hosted VoIP platform using our secure and adaptable SIP trunking options.
          </p>
        </div>

        <div className="inbound-text-section">
          <h3 className="inbound-subsection-title">Global DID Coverage</h3>
          <p className="inbound-section-text">
            Obtain local, national, toll-free, and mobile DIDs across 90+ countries. Whether establishing a presence in new markets or improving customer accessibility, DirectRoutes Networks provides the numbers you need.
          </p>
        </div>

        <div className="inbound-text-section">
          <h3 className="inbound-subsection-title">Regulatory Compliance & Number Porting</h3>
          <p className="inbound-section-text">
            We handle compliance with local telecom regulations and support number portability in key regions, ensuring smooth, risk-free transitions.
          </p>
        </div>

        <div className="inbound-text-section">
          <h3 className="inbound-subsection-title">Scalable & Redundant Infrastructure</h3>
          <p className="inbound-section-text">
            Our network is designed to scale with your business while delivering the reliability you require. Benefit from 99.999% uptime and intelligent failover systems that keep your operations running seamlessly.
          </p>
        </div>

        <div className="inbound-cta">
          <p className="inbound-cta-text">
            Partner with DirectRoutes Networks to elevate your global voice connectivity, enhance customer access, and ensure your business communications are always mission-ready.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InboundOrigination;
